import { getWebActivityList } from "../../webBridge";
import { useCallback, useEffect, useState } from "react";
import { WebActivityListItem } from "../../webInterface";
import { Button, Col, DatePicker, Form, Input, List, message, Row, Typography } from "antd";
import { CalendarOutlined, UserOutlined,  EnvironmentOutlined } from '@ant-design/icons';

const { Title, Text, Link } = Typography;

const WebActivities: React.FC = () => {
    //const data = useOutletContext() as UserInfo;
    const [form] = Form.useForm();
    const [messageApi, contextHolder] = message.useMessage();
    const [loadingState, setLoadingState] = useState(false);
    const [originItems, setOriginItems] = useState<WebActivityListItem[]>([]);
    const [filterItems, setFilterItems] = useState<WebActivityListItem[]>([]);
    
    const handleGetActivities = useCallback(async () => {
        try {
            setLoadingState(true);
            const res = await getWebActivityList();
            if (res.status === 200) {
                const resp = await res.json() as {"items": WebActivityListItem[]};
                setOriginItems(resp.items);
                setFilterItems(resp.items);
            } else {
                messageApi.error('Failed to fetch activities');
            }
        } catch (error) {
            messageApi.error('Error fetching activities');
        } finally {
            setLoadingState(false);
        }
    }, [messageApi]);

    const doSearch = (values: any) => {
        const formValues = values || form.getFieldsValue();
        const { keyword, start_date, end_date } = formValues;

        const filteredItems = originItems.filter(item => {
            if (keyword && !item.name.toLowerCase().includes(keyword.toLowerCase())) {
                return false;
            }

            if (start_date || end_date) {
                const itemStartDate = new Date(item.start_at);
                const itemEndDate = new Date(item.end_at);
                
                if (start_date && itemStartDate < start_date) {
                    return false;
                }
                
                if (end_date && itemEndDate > end_date) {
                    return false;
                }
            }

            return true;
        });

        setFilterItems(filteredItems);
    }

    useEffect(() => {
        handleGetActivities();
    }, [handleGetActivities]);

    return (
        <>
            {contextHolder}
            <div style={{ background: "white", borderRadius: 4, boxShadow: "0 0 3px 0 #cbcbcb", padding: 20, marginBottom: 20 }}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 20 }}>
                    <Col>
                        <Title level={4}>Activities</Title>
                    </Col>
                </Row>

                <Form initialValues={{keyword: "", start_date: null, end_date: null}} layout="vertical" form={form} name="searchForm" onFinish={doSearch}>
                    <Row gutter={24}>
                        <Col sm={8}>
                            <Form.Item label="Search Events" name="keyword">
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col sm={8}>
                            <Form.Item label="Start Date" name="start_date">
                                <DatePicker style={{width:"100%"}} />
                            </Form.Item>
                        </Col>

                        <Col sm={8}>
                            <Form.Item label="End Date" name="end_date">
                                <DatePicker style={{width:"100%"}} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Form.Item>
                        <Button type="primary" onClick={() => doSearch(null)} loading={loadingState}>Search</Button>
                    </Form.Item>
                </Form>
            </div>

            <List
                grid={{
                    gutter: 16,
                    xs: 1,
                    sm: 2,
                    md: 4,
                    lg: 4,
                    xl: 4,
                    xxl: 3,
                }}
                dataSource={filterItems}
                renderItem={(item: WebActivityListItem) => (
                    <List.Item>
                        <div style={{ background: "white", borderRadius: 4, boxShadow: "0 0 3px 0 #cbcbcb", padding: 20 }}>
                            <Title level={4}>
                                <Link href={`/web/activity/${item.id}/info`}>{item.name}</Link>
                            </Title>
                            <Text><EnvironmentOutlined /> {item.options?.location}</Text><br />
                            <Text><CalendarOutlined /> {item.start_at} ~ {item.end_at}</Text><br />
                            <Text><UserOutlined /> {item.participant_count} Participants</Text><br />
                        </div>
                    </List.Item>
                )}
            />
        </>
    )
}

export default WebActivities;
